import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent, NgxDatatableModule } from '@siemens/ngx-datatable';
import { ToastrService } from '@shared/services/toastr.service';
import { PageView } from '@shared/enums/enums';
import { AuthService } from '@shared/services/auth.service';
import { ElasticsearchApiService } from '@shared/services/elasticsearch/elasticsearch-api.service';
import { NgIf } from '@angular/common';
import { TimestampCellComponent } from '@shared/components/timestamp-cell/timestamp-cell.component';
import { FormsModule } from '@angular/forms';
import * as pager from '@shared/pager';

@Component({
  selector: 'app-elasticsearch',
  templateUrl: './elasticsearch.component.html',
  styleUrls: ['./elasticsearch.component.scss'],
  imports: [NgIf, NgxDatatableModule, TimestampCellComponent, FormsModule, TranslatePipe],
})
export class ElasticsearchComponent implements OnInit {
  lang: string;
  elasticsearch: any = {};
  elasticsearchs: any = [];
  pageViews = PageView;
  showView: PageView = PageView.LIST;
  @ViewChild('myTable') set datatable(table: DatatableComponent) {
    table.columnMode = ColumnMode.force; // make resizing table header working
  }
  @ViewChild('modal') modal: any;
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private auth: AuthService,
    private elasticsearchApiService: ElasticsearchApiService,
  ) {}

  ngOnInit() {
    this.lang = this.auth.getCurrentLanguage();
    this.getElasticsearch();
  }

  editEs(p: any) {
    this.elasticsearch = {};
    this.showView = PageView.CREATE;
    this.elasticsearch = p === undefined ? {} : { ...p };
  }

  getElasticsearch() {
    this.http
      .post('elasticsearch/get', {
        data: {},
      })
      .subscribe((res: any) => {
        if (!res.hasError) {
          this.elasticsearchs = res.items;
        }
      });
  }

  onCreateEs(p: any) {
    if (p.nom === undefined || p.nom.trim() === '') {
      this.toastr.error('SaisirLeLibelle');
      return;
    }
    if (p.endpoint === undefined || p.endpoint.trim() === '') {
      this.toastr.error('SaisirLendpoint');
      return;
    }
    this.http
      .post('elasticsearch/create', {
        datas: [
          {
            uid: p.uid,
            nom: p.nom,
            endpoint: p.endpoint,
            endpointEs: p.endpointEs,
            credentialUsername: p.credentialUsername,
            credentialPassword: p.credentialPassword,
            clusterName: p.clusterName,
            indexName: p.indexName,
          },
        ],
      })
      .subscribe((res: any) => {
        if (!res.hasError) {
          this.showView = PageView.LIST;
          this.getElasticsearch();
          this.toastr.success('EnregistrementReussi');
        }
      });
  }

  onUpdateEs(p: any) {
    this.http
      .post('elasticsearch/update', {
        datas: [
          {
            id: p.id,
            uid: p.uid,
            nom: p.nom,
            endpoint: p.endpoint,
            endpointEs: p.endpointEs,
            credentialUsername: p.credentialUsername,
            credentialPassword: p.credentialPassword,
            clusterName: p.clusterName,
            indexName: p.indexName,
          },
        ],
      })
      .subscribe((res: any) => {
        if (!res.hasError) {
          this.showView = PageView.LIST;
          this.getElasticsearch();
          this.toastr.success('MiseAJourReussie');
        } else {
          this.toastr.error(res.status.message);
        }
      });
  }

  onDeleteEs(p: any) {
    const req = {
      datas: [p],
    };
    this.http.post('elasticsearch/delete', req).subscribe((res: any) => {
      if (!res.hasError) {
        this.getElasticsearch();
        this.toastr.success('SuppressionSucces');
      } else {
        this.toastr.error('SuppressionEchoue');
      }
    });
  }

  protected export(row: any) {
    this.elasticsearchApiService.reprovisionAll(row.id).subscribe((res: any) => {
      if (!res.hasError) {
        this.toastr.success('ESReprovisionneSucces');
      }
    });
  }

  protected readonly pager = pager;
}
